import { useAuth } from '../hooks/useAuth';
import { LandingPageContent } from './LandingPageContent';

export function LandingPage() {
  const { user } = useAuth();

  return <LandingPageContent showDashboardCta={Boolean(user)} />;
}
